import React from 'react'
import DefaultButton from '../../Button/Button'
import ModalInfo from './ModalInfo'
import { removeUnderscore } from '../../../utils/removeUnderscore'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isConfirmDisabled?: boolean
  isConfirming?: boolean
  guest: {
    name: string
    code: string
    destination: string
    date: string
    validity: string
    codeType: string
  }
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, guest, onConfirm ,isConfirmDisabled, isConfirming}) => {
  if (!isOpen) return null

  const getHeading = (codeType: string) => {
    const formattedHeading = removeUnderscore(codeType)

    switch (formattedHeading.toUpperCase()) {
      case 'REOCCURRING':
        return 'Reoccurring Guest Details'
      case 'ONE TIME':
        return 'One-time Guest Details'
      default:
        return 'Guest Details'
    }
  }

  return (
    <div className="fixed z-[998] inset-0 bg-gray-300/60 flex justify-center items-center p-4">
      <div className="relative bg-white py-4 sm:py-6 md:py-8 px-4 sm:px-6 rounded-lg w-full max-w-sm md:max-w-lg lg:max-w-xl max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-700 hover:text-black text-xl sm:text-2xl transition-colors flex-shrink-0"
        >
          &times;
        </button>
        <p className="font-semibold text-base sm:text-lg md:text-xl mb-4 sm:mb-6 pr-8">
          {getHeading(guest.codeType)}{' '}
        </p>
        <div className="space-y-2 sm:space-y-3 mb-6">
          <ModalInfo label="Name of guest" value={guest.name} />
          <ModalInfo
            label="Date"
            value={
              guest.date
                ? `${new Date(guest.date).toLocaleDateString('en-US', {
                    weekday: 'short', // Mon
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  })}. ${new Date(guest.date)
                    .toLocaleTimeString('en-US', {
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true,
                    })
                    .toLowerCase()}`
                : ''
            }
          />

          <ModalInfo label="Code" value={guest.code} />
          <ModalInfo label="Destination" value={guest.destination} />
          <ModalInfo
            label="Validity"
            value={
              guest.validity
                ? `Valid till ${new Date(guest.validity).toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}`
                : ''
            }
          />

          <ModalInfo label="Code Type" value={guest.codeType} />
        </div>
        <div className="flex flex-col-reverse sm:flex-row gap-3 sm:gap-2 mt-4 sm:mt-6">
          <DefaultButton
            buttonType="secondary"
            size="lg"
            fontSize="14"
            onClick={onClose}
            className="w-full sm:w-auto border border-gray-200 text-xs sm:text-sm"
          >
            Close
          </DefaultButton>
          <DefaultButton
            type="submit"
            size="lg"
            fontSize="14"
            onClick={onConfirm}
            className="w-full sm:w-auto text-xs sm:text-sm"
            loading={isConfirming}
            loadingText="Submitting..."
            disabled={isConfirmDisabled || isConfirming}
          >
            Confirm Entry
          </DefaultButton>
        </div>
      </div>
    </div>
  )
}

export default Modal
